import createVueApp from '@/common/create_app'

Styxie.Initializers.LocalOpticsQuoteCheckouts = {
  show: async(props) => {
    const { default: QuoteCheckout } = await import('@/vue_widgets/local_optics/checkout/QuoteCheckout.vue')
    createVueApp(QuoteCheckout, { props })
  }
}
